var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1343_6922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7958 16.6708H21.6C21.4875 16.6708 21.4083 16.575 21.4458 16.4875L25.3167 6.85833C25.375 6.7125 25.1583 6.60416 25.0417 6.72083C23.7917 7.97083 10.1292 22.0167 9.07082 23.1167C8.98332 23.2042 9.07082 23.3375 9.20415 23.3375L18.6417 23.3625L14.7583 33.15C14.6958 33.2958 14.9167 33.4042 15.0333 33.2875C16.1458 32.1667 29.5833 18.3083 30.9292 16.8917C31.0167 16.8042 30.9333 16.6708 30.7958 16.6708Z",
    fill: "#84B0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 3.33748C23.2964 3.33748 26.5187 4.31497 29.2595 6.14632C32.0003 7.97768 34.1365 10.5807 35.398 13.6261C36.6595 16.6715 36.9895 20.0226 36.3464 23.2557C35.7033 26.4887 34.116 29.4584 31.7851 31.7893C29.4542 34.1201 26.4845 35.7075 23.2515 36.3506C20.0185 36.9937 16.6674 36.6636 13.622 35.4021C10.5765 34.1407 7.97354 32.0045 6.14218 29.2637C4.31083 26.5228 3.33334 23.3005 3.33334 20.0042C3.33334 15.5839 5.08929 11.3446 8.2149 8.21904C11.3405 5.09343 15.5797 3.33748 20 3.33748V3.33748ZM20 0.00415039C16.0444 0.00415039 12.1776 1.17713 8.8886 3.37476C5.59962 5.57239 3.03617 8.69596 1.52242 12.3505C0.00866572 16.005 -0.387401 20.0263 0.384303 23.906C1.15601 27.7856 3.06082 31.3492 5.85787 34.1463C8.65492 36.9433 12.2186 38.8482 16.0982 39.6199C19.9778 40.3916 23.9992 39.9955 27.6537 38.4817C31.3082 36.968 34.4318 34.4045 36.6294 31.1156C38.827 27.8266 40 23.9598 40 20.0042C40 14.6998 37.8929 9.61274 34.1421 5.86202C30.3914 2.11129 25.3043 0.00415039 20 0.00415039V0.00415039Z",
    fill: "#84B0DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1343_6922"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartService);
export default __webpack_public_path__ + "static/media/StartService.e959f275e28eed0d20f6f026b13e02d4.svg";
export { ForwardRef as ReactComponent };